module.exports = __webpack_public_path__ + "static/media/backup_01.d2cf55ec.svg";